import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'fees',
    lazy: async () => ({ Component: (await import('./FeesPage')).FeesPage }),
  },
];
